import {Card, DataStatus} from 'platform/components';
import {Scroll, Text} from 'platform/foundation';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {useGetVehicleOrderFactoryRecordQuery} from '@dms/api/new-vehicle';
import i18n from '@dms/i18n';

import {EMPTY_PLACEHOLDER} from 'shared/web';

type FactoryRecordProps = {
  orderId: string;
};

function FactoryRecordBody(props: FactoryRecordProps) {
  const recordQuery = useGetVehicleOrderFactoryRecordQuery({orderId: props.orderId});
  const record = recordQuery.currentData?.record;

  return (
    <DataStatus
      isLoading={recordQuery.isFetching}
      isError={recordQuery.isError}
      errorAction={{title: i18n.t('general.actions.retry'), onClick: recordQuery.refetch}}
      data-testid="new-vehicle-factory-record-status"
    >
      {isNotNilOrEmpty(record) ? (
        <Scroll auto maxHeight={80}>
          <pre
            data-dd-privacy="hidden"
            data-dd-action-name="new-vehicle-factory-record"
            data-testid="new-vehicle-factory-record-json"
          >
            {JSON.stringify(record, null, 2)}
          </pre>
        </Scroll>
      ) : (
        <Text size="small">{EMPTY_PLACEHOLDER}</Text>
      )}
    </DataStatus>
  );
}

/** Read-only latest factory record; Card mounts the body, so the record loads only when the block opens. */
export function FactoryRecord(props: FactoryRecordProps) {
  return (
    <Card
      title={i18n.t('entity.newVehicle.order.factoryRecord')}
      variant="inlineGrey"
      isExpandable
      isClosedByDefault
      data-testid="new-vehicle-factory-record"
    >
      <FactoryRecordBody orderId={props.orderId} />
    </Card>
  );
}
